import { render } from "./Referrer.vue?vue&type=template&id=17103897&ts=true&lang=pug"
import script from "./Referrer.vue?vue&type=script&lang=ts"
export * from "./Referrer.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__